/**
 * Background SVG component for the sectors section
 * Provides blue gradient background with animated circles
 */
export function TheSectorsSectionBG() {
  return (
    <svg
      viewBox="0 0 1920 1155"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute inset-0 w-full h-full object-cover"
      preserveAspectRatio="xMidYMid slice"
    >
      <g clipPath="url(#clip0_674_9587)" className="w-full h-full">
        <rect className="absolute inset-0 w-full h-full" fill="#011E62" />
        <g filter="url(#filter0_f_674_9587)">
          <circle cx="261" cy="577" r="199" fill="#0046BB" />
        </g>
        <g filter="url(#filter1_f_674_9587)">
          <circle cx="1226" cy="109" r="199" fill="#0046BB" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_674_9587"
          x="-238"
          y="78"
          width="998"
          height="998"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_674_9587"
          />
        </filter>
        <filter
          id="filter1_f_674_9587"
          x="727"
          y="-390"
          width="998"
          height="998"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_674_9587"
          />
        </filter>
        <clipPath id="clip0_674_9587">
          <rect width="1920" height="1155" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}